import { render, staticRenderFns } from "./purchasedContentChild.vue?vue&type=template&id=34688532&scoped=true"
import script from "./purchasedContentChild.vue?vue&type=script&lang=js"
export * from "./purchasedContentChild.vue?vue&type=script&lang=js"
import style0 from "./purchasedContentChild.vue?vue&type=style&index=0&id=34688532&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34688532",
  null
  
)

export default component.exports